/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useMutation } from 'react-query'

import { updateBillingAccountV1 } from '@modules/billing-api/v1/callers'
import type { operations } from '@modules/billing-api/v1/types'

const useUpdateBillingAccount = () =>
  useMutation({
    mutationFn: (args: {
      pathParameters: operations['updateBillingAccountV1']['parameters']['path']
      body: operations['updateBillingAccountV1']['requestBody']['content']['application/json']
    }) => updateBillingAccountV1(args),
  })

export default useUpdateBillingAccount
